import styled from "styled-components";

export const  SearchInput =styled.input`

width:100% ;
padding:1rem 2rem ;
outline:none ;
border:1px solid  hsl(0, 0%, 52%) ;

`